import {loginToAWD} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import {AWDLoginActionType, login, showLoginFailure} from 'ApplicationEntry/ducks/AWDLogin';
import {ValidatingAWDLogin} from 'ApplicationEntry/models/AWDLogin';
import {push} from 'connected-react-router';
import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {LocalStorageKey, toLocalStorage} from 'Shared/utilities/localStorage';

export const parseResponse = (awdLoginResponse: string) => {
  const requestBodyString = awdLoginResponse.slice(awdLoginResponse.indexOf('body:') + 5);
  const trimmedRequestBodyString = requestBodyString.slice(0, requestBodyString.length - 3);

  return JSON.parse(trimmedRequestBodyString);
};

type LoginToAWDPayload = {
  dst_session: string;
  csrf_token: string;
};

function* loginToAWDSaga() {
  yield takeLatest(AWDLoginActionType.LOGIN, function*(action: ReturnType<typeof login>) {
    const {awdLogin} = action.payload;
    const {username, password} = awdLogin;
    const result: AsyncResult<LoginToAWDPayload> = yield call(loginToAWD, username.value, password.value);

    if (E.isRight(result)) {
      const {dst_session: dstSession, csrf_token: token} = result.right;

      toLocalStorage(LocalStorageKey.AWDCsrfToken)(token)();
      toLocalStorage(LocalStorageKey.AWDDSTSession)(dstSession)();

      yield all([put(createSnackbar('Login Successful')), put(push(ApplicationEntryRouteConstants.WorkQueue))]);
    } else {
      yield put(showLoginFailure(ValidatingAWDLogin.create(awdLogin)));
    }
  });
}

export default function*() {
  yield all([loginToAWDSaga()]);
}
